module.exports = __webpack_public_path__ + "img/fig07.b65b959a.jpg";